export default function ($scope, Restangular, current, licences, active, unused) {

    $scope.has_company = GetData().currentUser.company;
    $scope.has_admin = HasRole('admin');
    $scope.has_patient = !HasRole(['superadmin', 'company', 'prenscriptor']);

    $scope.licences = licences;

    $scope.user = current;
    $scope.month = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];

    $scope.roles = {
        'ROLE_PATIENT' : 'Patient',
        'ROLE_PRENSCRIPTOR' : 'Prescriber',
        'ROLE_COMPANY' : 'Company'
    };

    if($scope.roles instanceof Array){
        $scope.user.type = $scope.roles[$scope.user.roles[0]];
    }else{
        $scope.user.type = $scope.roles[$scope.user.roles];
    }

    // Subscriptions
    $scope.user.use_subscriptions = active.length+'/'+unused.length;



    // Invoices
    if($scope.user.purchases.length)
    {
        let last = null;

        $scope.user.purchases.forEach(function(v, i){
            if(v.status <= 99 && v.updated)
                last = v;
        });

        if(last && last.product){
            let product = last.product;

            let date = ParseDate(last.updated);
            let day = date.getDate();
            let month = date.getMonth();

            $scope.last_pay = {
                total: product.price,
                day: day,
                month: $scope.month[month].toString().toLowerCase()
            };
        }
    }
};


/** WEBPACK FOOTER **
 ** ./js/theme/account/controller.js
 **/